import { PROVIDE_CLIENT_INTAKE_FORM_ITEMS_STATE } from '@db-access/clientIntakeFormItems';
import { IntakeFormItemsState } from './state/intake-form-items.state';
import { provideStates } from '@ngxs/store';

export const PROVIDE_INTAKE_FORM_ITEMS_STATE = [
	provideStates([IntakeFormItemsState]),
	...PROVIDE_CLIENT_INTAKE_FORM_ITEMS_STATE,
];
